export default __webpack_public_path__ + "static/media/img_major04_1.ead575ab.jpg";